import React from "react";
import styled from "@emotion/styled";

import { COLOR_OCEAN_GREEN, COLOR_WHITE } from "../../constants/styles";
import { Button, IProps } from "../../UI/Button";
import { darken } from "@mui/system/colorManipulator";

const StyledButton = styled(Button)`
  &:not([disabled]) {
    background-color: ${COLOR_OCEAN_GREEN} !important;
    span {
      color: ${COLOR_WHITE} !important;
    }

    &:hover,
    &:focus {
      background-color: ${darken(COLOR_OCEAN_GREEN, 0.1)} !important;
    }
  }
`;

export const SuccessButton: React.FC<IProps> = (props) => <StyledButton {...(props as any)} />;
